import type { CSSProperties } from 'react';
import { useTranslation } from 'react-i18next';

export function LoadingScreen() {
  const { i18n } = useTranslation();
  const isEn = i18n.resolvedLanguage?.startsWith('en');

  return (
    <main className="loading-screen" aria-live="polite" aria-busy="true">
      <div className="loading-screen__veil" />
      <div className="loading-screen__particles" aria-hidden="true">
        {Array.from({ length: 10 }).map((_, index) => (
          <span
            key={index}
            style={{ '--delay': `${index * -0.45}s`, '--offset': `${10 + index * 8}%` } as CSSProperties}
          />
        ))}
      </div>
      <div className="loading-screen__content">
        <div className="loading-screen__crest" aria-hidden="true">
          <div className="loading-screen__crest-ring" />
          <div className="loading-mark">A</div>
        </div>
        <p className="loading-screen__eyebrow">{isEn ? 'Preparing the journey' : 'Menyiapkan perjalanan'}</p>
        <h1>AmertaSala</h1>
        <strong>{isEn ? 'Weaving Solo’s stories into your next scene.' : 'Merangkai kisah Solo ke dalam pengalamanmu berikutnya.'}</strong>
        <div className="loading-screen__progress" aria-hidden="true"><span /></div>
        <p className="loading-screen__hint">{isEn ? 'Loading city stories, routes, and living heritage…' : 'Memuat cerita kota, rute, dan warisan yang terus hidup…'}</p>
      </div>
    </main>
  );
}
